import { useState } from 'react'

// icons
import { RxCross2 } from 'react-icons/rx'
import { LuUpload } from 'react-icons/lu'
import { FaCircleCheck } from 'react-icons/fa6'
import { MdDelete } from 'react-icons/md'

import { Dropdown, Button, Typography, Drawer, Upload, message } from 'antd'
import { IoIosArrowDown } from 'react-icons/io'

// context
import { useUpload } from '../../../context/UploadResumeContext'

// constants
import { JOB_APPLICATIONS_STATUS } from '../../../constants/jobs'

// css
import '../index.css'
import ManuallyCandidateAdd from '../../candidate/components/manually-candidate-add'

export default function AddCandidatesDropdown({ state }) {
    const { Title, Text } = Typography

    const [openResumeDrawer, setOpenResumeDrawer] = useState(false)
    const [fileList, setFileList] = useState([])
    const [openManuallyModel, setOpenManuallyModel] = useState(false)

    const { addUploads } = useUpload()

    const menuItems = [
        {
            key: 'add_resume',
            label: (
                <div className="px-3 py-2">
                    <Title level={5}>Add Resume</Title>
                    <Text>Add candidate with resume</Text>
                </div>
            ),
        },
        {
            key: 'add_manual',
            label: (
                <div className="px-3 py-2">
                    <Title level={5}>Add Manually</Title>
                    <Text>Enter candidate name and details</Text>
                </div>
            ),
        },
    ]
    const onClick = ({ key }) => {
        if (key === 'add_resume') {
            setOpenResumeDrawer(true)
        } else if (key === 'add_manual') {
            setOpenManuallyModel(true)
        }
    }

    return (
        <>
            <div className="d-flex justify-content-center bg-white wrapper">
                <Dropdown
                    menu={{ items: menuItems, onClick }}
                    trigger={['click']}
                    overlayClassName="add-candidates-menu"
                >
                    <Button
                        type="default"
                        size="middle"
                        className="d-flex align-items-center gap-2 rounded-3"
                        style={{
                            backgroundColor: '#f3f5f8',
                            border: '1px solid transparent',
                        }}
                    >
                        <Text
                            style={{
                                color: '#313b46',
                                fontWeight: 'bold',
                            }}
                        >
                            Add Candidates
                        </Text>
                        <IoIosArrowDown color="black" />
                    </Button>
                </Dropdown>
            </div>
            <Drawer
                open={openResumeDrawer}
                onClose={() => {
                    setFileList([])
                    setOpenResumeDrawer(false)
                    setOpenManuallyModel(false)
                }}
                width={650}
                placement="bottom"
                className="resume-drawer"
                closeIcon={null}
                styles={{
                    body: {
                        padding: '14px 24px',
                    },
                    content: {
                        height: '80vh',
                    },
                    wrapper: {
                        minHeight: '80vh',
                        borderRadius: '16px 16px 0px 0px',
                    },
                }}
                title={
                    <div className="d-flex align-items-center justify-content-between">
                        <Title
                            style={{
                                color: '#313b46',
                            }}
                            level={4}
                        >
                            Add candidate
                        </Title>
                        <div className="d-flex align-items-center justify-center gap-3">
                            {fileList?.length > 0 && (
                                <Dropdown.Button
                                    onClick={() => {
                                        addUploads(
                                            fileList,
                                            'applied',
                                            state?.jobStatus
                                        )
                                        setFileList([])
                                        setOpenResumeDrawer(false)
                                    }}
                                    rootClassName="resume-upload-job"
                                    menu={{
                                        items: JOB_APPLICATIONS_STATUS.map(
                                            (status) => ({
                                                key: status.value,
                                                label: status.label,
                                            })
                                        ),
                                        onClick: ({ key }) => {
                                            addUploads(fileList, key)
                                            setFileList([])
                                            setOpenResumeDrawer(false)
                                        },
                                    }}
                                    type="primary"
                                    style={{
                                        height: '38px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        borderRadius: '6px',
                                        backgroundColor: '#4f46e5',
                                    }}
                                    icon={<IoIosArrowDown />}
                                >
                                    Add to Applied
                                </Dropdown.Button>
                            )}
                            <RxCross2
                                style={{
                                    cursor: 'pointer',
                                }}
                                onClick={() => setOpenResumeDrawer(false)}
                            />
                        </div>
                    </div>
                }
            >
                <div className="d-flex justify-content-center mt-5">
                    <Typography.Title
                        level={3}
                        className="text-center mb-4 drawer-title"
                    >
                        Add candidates with resume
                    </Typography.Title>
                </div>

                <div className="d-flex justify-content-center">
                    <div className="uploader-wrap">
                        <Upload.Dragger
                            multiple
                            maxCount={100}
                            accept=".pdf"
                            beforeUpload={(file) => {
                                const allowed = /\.(pdf)$/i.test(file.name)
                                if (!allowed) {
                                    message.error('Only .pdfs are allowed.')
                                    return Upload.LIST_IGNORE
                                }
                                if (file.size > 5 * 1024 * 1024) {
                                    message.error(
                                        'File must be smaller than 5MB.'
                                    )
                                    return Upload.LIST_IGNORE
                                }
                                return false
                            }}
                            onChange={({ fileList: list }) => setFileList(list)}
                            fileList={fileList}
                            showUploadList={false}
                            className="resume-dragger"
                            style={{
                                backgroundColor: '#fff',
                                padding: 0,
                            }}
                        >
                            {fileList.length > 0 ? (
                                <div className="custom-file-list">
                                    {fileList.map((file) => (
                                        <div
                                            key={file.uid}
                                            className="d-flex align-items-center justify-content-between border-none rounded px-2 py-0 mb-2"
                                            style={{
                                                background: '#f3f5f8',
                                            }}
                                        >
                                            <div className="d-flex align-items-center gap-2">
                                                <FaCircleCheck
                                                    color="#05b279"
                                                    size={16}
                                                />
                                                <Typography.Text>
                                                    {file.name}
                                                </Typography.Text>
                                            </div>

                                            <Button
                                                type="text"
                                                danger
                                                icon={
                                                    <MdDelete
                                                        color="#6a7381"
                                                        size={18}
                                                    />
                                                }
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                    setFileList((prev) =>
                                                        prev.filter(
                                                            (f) =>
                                                                f.uid !==
                                                                file.uid
                                                        )
                                                    )
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="dragger-icon">
                                    <LuUpload />
                                </div>
                            )}

                            <p className="dragger-main">
                                <Typography.Text
                                    strong
                                    style={{ color: '#4f46e5' }}
                                >
                                    Upload a file
                                </Typography.Text>
                                <Typography.Text>
                                    {' '}
                                    or drag and drop here
                                </Typography.Text>
                            </p>
                        </Upload.Dragger>

                        <p className="dragger-hint text-muted mt-3">
                            Upload up to 100 files, maximum file size 5MB,
                            acceptable file types .pdf.
                        </p>
                    </div>
                </div>
            </Drawer>
            {openManuallyModel && (
                <ManuallyCandidateAdd
                    openManuallyModel={openManuallyModel}
                    setOpenManuallyModel={setOpenManuallyModel}
                    state={state}
                />
            )}
        </>
    )
}
